document.addEventListener("DOMContentLoaded", () => {

    const track = document.querySelector(".gv-track");
    if (!track) return;

    const cards = Array.from(track.children);
    const prev = document.querySelector(".gv-prev");
    const next = document.querySelector(".gv-next");
    const pagination = document.querySelector(".gv-pagination");

    let current = 0;
    let autoplay;

    function perView() {
        if (window.innerWidth <= 768) return 1;
        if (window.innerWidth <= 990) return 2;
        return 4;
    }

    function pages() {
        return Math.max(1, cards.length - perView() + 1);
    }

    function cardWidth() {
        if (!cards.length) return 0;

        const gap = parseInt(getComputedStyle(track).gap) || 24;

        return cards[0].getBoundingClientRect().width + gap;
    }

    function update() {

        const move = current * cardWidth();

        track.style.transform = `translateX(-${move}px)`;

        document.querySelectorAll(".gv-pagination span").forEach((dot, i) => {
            dot.classList.toggle("active", i === current);
        });

    }

    function buildDots() {

        pagination.innerHTML = "";

        for (let i = 0; i < pages(); i++) {

            const dot = document.createElement("span");

            if (i === current)
                dot.classList.add("active");

            dot.addEventListener("click", () => {
                current = i;
                update();
                restart();
            });

            pagination.appendChild(dot);

        }

    }

    next.addEventListener("click", () => {

        current++;

        if (current >= pages())
            current = 0;

        update();

        restart();

    });

    prev.addEventListener("click", () => {

        current--;

        if (current < 0)
            current = pages() - 1;

        update();

        restart();

    });

    function start() {

        autoplay = setInterval(() => {

            current++;

            if (current >= pages())
                current = 0;

            update();

        }, 5000);

    }

    function restart() {

        clearInterval(autoplay);

        start();

    }

    /* Swipe */

    let startX = 0;

    track.addEventListener("touchstart", e => {

        startX = e.touches[0].clientX;

    });

    track.addEventListener("touchend", e => {

        const endX = e.changedTouches[0].clientX;

        if (startX - endX > 60) {

            current++;

            if (current >= pages())
                current = 0;

        }

        if (endX - startX > 60) {

            current--;

            if (current < 0)
                current = pages() - 1;

        }

        update();

        restart();

    });

    window.addEventListener("resize", () => {

        current = 0;

        buildDots();

        update();

    });

    buildDots();

    update();

    start();

});